module.exports = __webpack_public_path__ + "static/media/katusiime_ndera3.f17efc91.jpg";